jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/team-popup.js');
});


// String Color
function colorizeServiceTitles() {
  let serviceTitles = document.querySelectorAll('.service-thumbnail-title');

  serviceTitles.forEach(title => {
    let words = title.textContent.split(' ');
    let coloredHTML = '';

    if(words.length >= 2) {
      if(words.length === 2) {
        coloredHTML += `${words[0]} <span class="title-color">${words[1]}</span>`;

      } else {
        coloredHTML += `<span>${words[0]} ${words[1]}</span>`;
        for(let i = 2; i < words.length; i++) {
          coloredHTML += ` <span class="title-color">${words[i]}</span>`;
        }
      }

      title.innerHTML = coloredHTML;
    }
  });
}

colorizeServiceTitles();


// Function to get the sibling to Banner
document.addEventListener('DOMContentLoaded', function() {
  function addClassToBannerNext() {
    const banner = document.querySelector('.banner');

    if(banner) {
      const nextSection = banner.nextElementSibling;
      if(nextSection && nextSection.tagName.toLowerCase() === 'section') {
        nextSection.classList.add('banner-next');
      }
    }
  }

  addClassToBannerNext();
});


// Function to get the sibling to Footer
document.addEventListener('DOMContentLoaded', function() {
  function addClassToLastSection() {
    const footer = document.querySelector('footer');
    const mainSections = document.querySelectorAll('main section');

    if(footer && mainSections.length > 0) {
      const lastSection = mainSections[mainSections.length - 1];
      lastSection.classList.add('footer-prev');
    }
  }

  addClassToLastSection();
});